import { render, staticRenderFns } from "./the-nav-links.vue?vue&type=template&id=76869094&scoped=true&"
import script from "./the-nav-links.vue?vue&type=script&lang=js&"
export * from "./the-nav-links.vue?vue&type=script&lang=js&"
import style0 from "./the-nav-links.vue?vue&type=style&index=0&id=76869094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76869094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VTooltip})
